import React from "react";
import './styles.css'
import { ExamPaperType, Section } from "../../utils/interface/exam";
import { ExamSection } from "./sections";
import Logo from "../../assets/logo.webp";

interface ExamPaperProps {
    data: ExamPaperType;
}

export default function ExamPaper(props: ExamPaperProps) {

    const { data } = props;

    // console.log(data);
    

    const calculateMarks = (section: Section) => {
        let total = section.total_marks;
        let compulsaryQuestions = section.questions.filter(question => question.is_question_alternative).length;

        if (compulsaryQuestions === 0) {
            return {
                perQuestion: Math.round(total / section.questions.length),
                totalQuestions: section.questions.length
            };
        } else {
            let marksPerQues = Math.round(total / compulsaryQuestions);
            return {
                perQuestion: marksPerQues,
                totalQuestions: compulsaryQuestions
            };
        }


    }


    return (
        <div className="exam_paper">
            <div className="exam_wrapper">


                {/* HEADER */}
                <div className="exam_header">
                    <img
                        src={Logo}
                        alt="Chanakya Logo"
                        className="exam_header__logo"
                    />
                    <h2>{data.assessment_title}</h2>
                    <h2>Class - {data.class}</h2>
                    <h2>Subject : {data.subject}</h2>
                    <div className="exam_header_meta">
                        <h2>Time : {data.time/60} Hours</h2>
                        <h2>Max. Marks : {data.maximum_marks}</h2>
                    </div>
                </div>


                {/* INSTRUCTIONS */}

                <div className="exam_header exam_instructions">
                    <h2>General Instructions:</h2>
                    <ol style={{ marginTop: 5 }}>
                        {
                            data.instructions.map((instruction, index) => (
                                <li>{instruction}</li>
                            ))
                        }
                    </ol>
                </div>

                {/* SECTIONS */}
                {
                    data.sections.map((section, index) => (
                        <div className="exam_section" key={index}>
                            <div className="section_meta">
                                <h3 style={{color:'transparent'}}>[ {calculateMarks(section).perQuestion} X {calculateMarks(section).totalQuestions} = {section.total_marks} ]</h3>
                                <h2 className="section_title">{section.name}</h2>
                                <h3>[ {calculateMarks(section).perQuestion} X {calculateMarks(section).totalQuestions} = {section.total_marks} ]</h3>
                            </div>
                            <span className="section_description">{section.description}</span>
                            <div className="section_question_holder">
                                <ExamSection section={section} />
                            </div>
                        </div>
                    ))
                }


                <span className="branding">AI Exam by <a target='_blank' href="https://aichanakya.in/" rel="noreferrer">Chanakya AI Assessments</a></span>

            </div>
        </div>
    )
}